module.exports = __webpack_public_path__ + "media/1x1/aq-65448909.svg";